<template>
	<div class="legal-info">
		<div class="legal-info__content">
			<BreadCrumbs/>
            <h1>Юридическая информация</h1>
            <div>
                <pre>  
                    Наименование: ОБЩЕСТВО С ОГРАНИЧЕННОЙ
                    ОТВЕТСТВЕННОСТЬЮ "ЗОТА
                    СИСТЕМС
                </pre>
             
                <pre>
                    Адрес юридический: 660061,
                    КРАСНОЯРСКИЙ КРАЙ,
                    Г. КРАСНОЯРСК,
                    УЛ. КАЛИНИНА,
                    Д. 53А,
                    СТРОЕНИЕ 19 КАБИНЕТ 1
                </pre>

                <pre>
                    Адрес фактический: 660061,
                    КРАСНОЯРСКИЙ КРАЙ,
                    Г. КРАСНОЯРСК,
                    УЛ. КАЛИНИНА,
                    Д. 53А,
                    СТРОЕНИЕ 19 КАБИНЕТ 1
                </pre>

                <pre>
                    ИНН: 2 4 6 4 1 3 6 5 2 7
                    КПП: 246301001
                    ОГРН: 1 1 7 2 4 6 8 0 3 3 1 6 5
                    Основной код ОКВЭД: 62.01
                    Информация о видах ИТ‑деятельности: 1.01
                    Р/c: 40702810723300005901
                    Банк: ФИЛИАЛ "НОВОСИБИРСКИЙ" АО "АЛЬФА-БАНК"
                    БИК: 045004774
                    Корр/с: 30101810600000000774
                    Валюта: ₽, Российский рубль
                    Email: info@zota-systems.ru
                    Тел.: +7 (391) 251-10-30
                    Веб‑сайт: zota-systems.ru
                </pre>
            </div>
		</div>
	</div>
</template>

<script>
import BreadCrumbs from "@/components/BreadCrumbs";
import {mapGetters} from "vuex";

export default {
	name: 'LegalInfo',
	components: {BreadCrumbs},
	computed: {...mapGetters(['LEGAL_INFO'])}
}
</script>


<style scoped lang="scss">

.legal-info {
	&__content {
		max-width: 1816px;
		margin: 0 auto;
		padding: 145px 20px 105px;
		@media (max-width: 1920px) {
			@include adaptive-value("padding", 145 85, 20, 105 34, 20);
		}

		h1 {
			margin: 16px 0 32px;
			text-align: left;
            font-weight: 600;
            font-size: 31px;
            line-height: 40px;
			@media (max-width: 1920px) {
				@include adaptiv-fontAll(61, 25);
				@include adaptive-elem(line-height, 67, 32);
				@include adaptive-value("margin", 16 30, 0, 32 16, 0);
			}
		}

        p, pre {
            font-weight: normal;
            font-size: 18px;
            line-height: 28px;
            color: #0B0B0B;
            @media (max-width: 1920px) {
                @include adaptiv-fontAll(18, 16);
                @include adaptive-elem(line-height, 28, 24);
            }
        }

        pre {
            white-space: pre-line;
            margin-bottom: 16px;
        }
	}

}
</style>
